import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'core-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotFoundComponent {}
